import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import CreationsList from '../CreationsList';
import { useStyles } from 'styles/components/creationAccordion';

const Props = {
  creations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      deleted: PropTypes.number.isRequired,
      folder: PropTypes.number,
      thumb: PropTypes.string.isRequired,
      slide_id: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }),
  ).isRequired,
  shared: PropTypes.bool,
  addToFolderOption: PropTypes.bool,
  onOptionClick: PropTypes.func.isRequired,
  onModalActionClick: PropTypes.func.isRequired,
  onDeleteModalActionClick: PropTypes.func.isRequired,
};

export default function CreationsAccordion({
  children,
  creations,
  shared,
  addToFolderOption,
  onOptionClick,
  onModalActionClick,
  onDeleteModalActionClick,
}) {
  const classes = useStyles();

  return (
    <Accordion
      classes={{ root: classes.panel, expanded: classes.panelExpanded }}
      defaultExpanded={true}
    >
      <AccordionSummary
        classes={{ root: classes.panelSummary, content: classes.panelSummaryContent }}
        expandIcon={<ExpandMore />}
      >
        <Typography>
          <b>Creations</b>
        </Typography>
      </AccordionSummary>

      <AccordionDetails className={classes.panelDetails}>
        <CreationsList
          creations={creations}
          shared={shared}
          addToFolderOption={addToFolderOption}
          onOptionClick={onOptionClick}
          onModalActionClick={onModalActionClick}
          onDeleteModalActionClick={onDeleteModalActionClick}
        />

        {children}
      </AccordionDetails>
    </Accordion>
  );
}

CreationsAccordion.propTypes = Props;
